<template>
  <div>
    <CAlert
      v-if="reqResponse.message"
      class="mt-4 max-w-500 m-auto"
      :color="reqResponse.type"
      :show="!!reqResponse.message"
    >
      {{ reqResponse.message }}
    </CAlert>
    <div>
      <div
        v-for="(form, index) in formsCount"
        :key="index"
        class="pt-4 CreateAppoinmentsPassForm"
      >
        <CreateAppoinmentsPassForm
          ref="AppoinmentsPassForm"
          :is-multiple="!editablePass"
          :form-index="index"
          :periods="periods"
          :editable-pass="editablePass"
          is-in-view="true"
          @app-pass-updated="$emit('newAptPassCreated')"
        />
      </div>
    </div>
    <div
      v-if="!editablePass"
      class="d-flex align-items-center justify-content-center mb-4"
    >
      <div @click="validate()">
        <CLoadingButton
          :spinner="isLoading"
          :disabled="isLoading"
          :loading="isLoading"
          class="me-2 px-4 py-3 px-sm-5 py-sm-3 btn bg-gradient-blue text-white"
        >
          Submit
        </CLoadingButton>
      </div>
      <CButton
        v-if="formsCount < 200"
        class="me-2 p-small bg-gradient-blue"
        @click="addForm"
      >
        <span class="btn bg-white px-4 d-flex align-items-center"
          ><i class="flaticon-plus icon-16 m-0 me-2" />
          <b class="text-graident-blue">Add</b></span
        >
      </CButton>
      <CButton
        v-if="formsCount > 1"
        class="me-2 p-small bg-gradient-blue"
        @click="removeForm"
      >
        <span class="btn bg-white px-4 d-flex align-items-center"
          ><i class="flaticon-minus icon-16 m-0" />
          <b class="text-graident-blue"
        /></span>
      </CButton>
    </div>
  </div>
</template>

<script>
import CreateAppoinmentsPassForm from "@/components/Forms/CreateAppoinmentsPassForm"
import moment from "moment"

export default {
  name: "MultipleForm",
  components: {
    CreateAppoinmentsPassForm
  },
  props: ["periods", "isInView", "editablePass"],
  emits: ["newAptPassCreated"],
  data() {
    return {
      formsCount: 1,
      isInvalid: true,
      isLoading: false,
      formDataCollection: [],
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      formsCollection: []
    }
  },
  computed: {
    forms() {
      return this.$refs.AppoinmentsPassForm
    },
    prevFormData() {
      const prevFormData = this.formsCollection[this.formsCount - 2]
        ? this.forms[this.formsCount - 2].form
        : null
      this.addForm()
      return prevFormData
    }
  },
  watch: {
    editablePass: function (pass) {
      if (pass) {
        this.resetMultipleForm()
      }
    }
  },
  created() {
    this.formsCollection = this.$refs.AppoinmentsPassForm
  },
  methods: {
    validate() {
      this.resetResponseMessages()
      this.isInvalid = false
      this.formDataCollection = []
      this.$refs.AppoinmentsPassForm.forEach((form) => {
        form.v$.$touch()
        if (form.v$.form.$invalid) {
          this.isInvalid = true
        } else {
          this.formDataCollection.push(form.form)
        }
      })

      if (!this.isInvalid) {
        this.submit()
      }
    },
    submit() {
      const appointments = []
      this.formDataCollection.forEach((form) => {
        form.time = form.time ? form.time : moment().format("HH:mm")
        appointments.push({
          from_id: form.from_id ? form.from_id.value.id : form.from_id,
          to_id: form.to_id ? form.to_id.value.id : form.to_id,
          from_type: form.from_id ? form.from_id.value.type : form.from_id,
          to_type: form.to_id ? form.to_id.value.type : form.to_id,
          for_date: this.$helpers.currTzDateTime(form.for_date, form.time),
          for_time: form.time,
          period_id: form.period_id ? form.period_id.value : form.period_id,
          reason: form.reason,
          user_id: form.user_id ? form.user_id.value.id : form.user_id,
          recurrence_type: form.recurrence_type,
          recurrence_days: JSON.stringify({
            days: form.recurrence_days
          }),
          recurrence_end_at: form.recurrence_end_at
            ? this.$helpers.currTzDate(form.recurrence_end_at)
            : null,
          recurrence_week: form.recurrence_week
        })
      })

      this.createAppointmentPasses(appointments)
    },
    createAppointmentPasses(appointments) {
      this.isLoading = true
      this.$store
        .dispatch("adultAptPass/createAppointmentPass", {
          appointments
        })
        .then(() => {
          this.resetMultipleForm()
          this.setSuccessResponse("Successfully created.")
          this.$emit("newAptPassCreated")
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.setFormsErrors(message, errors)
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    setFormsErrors(message, errors) {
      this.$refs.AppoinmentsPassForm.forEach((form) => {
        form.setErrorResponse(message, errors)
      })
    },
    resetMultipleForm() {
      this.resetResponseMessages()
      this.$helpers.scrollToTop()
      const resetForms = new Promise((resolve) => {
        this.$refs.AppoinmentsPassForm.forEach((form, index, array) => {
          form.resetForm()
          form.resetResponseMessages()
          if (index === array.length - 1) resolve()
        })
      })
      resetForms.then(() => {
        this.formsCount = 1
        this.isInvalid = true
        this.isLoading = false
        this.formDataCollection = []
      })
    },
    addForm() {
      this.formsCount++
      this.formsCollection = this.$refs.AppoinmentsPassForm
      this.duplicateFormData()
    },
    removeForm() {
      this.formsCount--
      const body = document.getElementsByClassName("c-body")[0]
      const element = document.getElementsByClassName(
        "CreateAppoinmentsPassForm"
      )[this.formsCount - 1]
      if (element) {
        element.scrollIntoView()
        body.scrollTop =
          this.formsCount && this.formsCount == 1
            ? body.scrollTop - 80
            : body.scrollTop - 15
      }
    },
    duplicateFormData() {
      const formsLen = this.$refs.AppoinmentsPassForm.length
      const current = this.$refs.AppoinmentsPassForm[formsLen - 1]
      if (current) {
        setTimeout(() => {
          const newForm = this.$refs.AppoinmentsPassForm[formsLen]
          if (newForm) {
            newForm.setFormData(current.form)
          }
        }, 500)
      }
    }
  }
}
</script>

<style></style>
